import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <h4 class="mb-3 bold text-center">Kampo de mirakloj</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Ne kaŝu vian monon vi en banko aŭ ŝtrumpet’, <br/>
        Alportu vian monon vi, por ne okazu plag’, <br/>
        Kaj en meznokto gardu vian monon en sekret’, <br/>
        Kaj en meznokto gardu vian monon sub la fag’,
      </p>

      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf:</span> <br/>
        Kreskanta nek en montoj, nek en val’, <br/>
        Nek en arbaro, nek sur voja rand’, <br/>
        Staranta en la kampo, kampo, kamp-virtual’, <br/>
        Kampo mirakla en stultula land’.
      </p>

      <p class="poem-block mb-3">
        Akvumu nepre monon vi kaj stamfu per la tret’, <br/>
        Kaj kreskos sur la arbo ĉi, donac’ de iu mag’, <br/>
        Arĝenta foliaro, bela krono de l’ veget’, <br/>
        La ora foliaro, brila krono de la fag’,
      </p>
      
      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf.</span>
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Dueto de Vulpino Alisa kaj Kato Bazilio</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Dum vivas en la mondo fanfaron’, <br/>
        Ne plendu ni pri l’ sorto sen bezon’.
      </p>

      <p class="poem-block mb-3">
        Kiel ĉielo blua belas! <br/>
        Rabadon tute ni ne celas! <br/>
        Ponard’ ne indas por vantul’, <br/>
        Oni lin flatu sen skrupul’, <br/>
        Kaj pretas li por manipul’, <br/>
        Pretas por manipul’!
      </p>

      <p class="poem-block mb-3">
        Dum avarec’ regadas en la mond’, <br/>
        Neniam malprosperas nia rond’.
      </p>

      <p class="poem-block mb-3">
        Kiel ĉielo blua belas! <br/>
        Rabadon tute ni ne celas! <br/>
        Ne indas mort’ por avarul’, <br/>
        Nur donu groŝon por kalkul’, <br/>
        Kaj pretas li por manipul’, <br/>
        Pretas por manipul’!
      </p>

      <p class="poem-block mb-3">
        Dum vivas en la mondo stultular’, <br/>
        Ni trompos kun profito, sen erar’!
      </p>

      <p class="poem-block mb-3">
        Kiel ĉielo blua belas! <br/>
        Rabadon tute ni ne celas! <br/>
        Ponard’ ne indas por stultul’, <br/>
        Por li sufiĉas vort-tumul’ <br/>
        Kaj pretas li por manipul’, <br/>
        Pretas por manipul’!
      </p>

      <p class="poem-block mb-3">
        Kiel ĉielo blua belas! <br/>
        Rabadon tute ni ne celas! <br/>
        Neniam mankos tiu tri’, <br/>
        Kaj nin minacas dank’ al ĝi <br/>
        Neniu averi’!
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Kantoj el la filmo «Aventuroj de Buratino»'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['0N7PjEZ3ZS0','zpWFKLmTiYg'],
    itemTranslator: `
      Muziko: A. Ribnikov, <br/>
      Teksto: Bulat Okuĝava, <br/>
      ${translator.esp}
    `
  }
}

export default item;